import { FC } from "react";
import { Helmet } from "react-helmet";
import { useLazyLoadQuery } from "react-relay";
import { Tooltip } from "react-tooltip";
import { graphql } from "relay-runtime";
import { useTranslation } from "rujira.ui";
import swapAni from "rujira.ui/src/assets/images/swap-circle.gif";
import {
  SwapThorchainQuery,
  SwapThorchainQuery$data,
} from "./__generated__/SwapThorchainQuery.graphql";
import { Context } from "./components/Context";
import { InputDestination } from "./components/InputDestination";
import { InputSource } from "./components/InputSource";
import { Quote } from "./components/Quote";

const rootQuery = graphql`
  query SwapThorchainQuery {
    thorchainV2 {
      ...InputDestinationFragment
    }
  }
`;

const Meta = () => {
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t("pageTitle")}</title>
      <meta name="description" content={t("description")} />
      <meta name="og:description" content={t("description")} />
      <meta name="twitter:description" content={t("description")} />
    </Helmet>
  );
};

export const Swap: FC = () => {
  const tc = useLazyLoadQuery<SwapThorchainQuery>(rootQuery, {});

  return (
    <Context>
      <Meta />
      <Content data={tc} />
      <Tooltip id="swap-tip" className="tooltip" float={true} />
    </Context>
  );
};

const Content: FC<{ data: SwapThorchainQuery$data }> = ({ data }) => {
  const { t } = useTranslation();
  return (
    <div className="rujira__main rujira__main--gradient swap">
      <div className="rujira__inner--pad">
        <div className="rujira__inner">
          <div className="text-center">
            <h1 className="h1 mb-1">{t("title")}</h1>
            <h2 className="fs-24 lh-32 fw-400 color-white">
              {t("description")}
            </h2>
          </div>

          <div className="mt-6">
            <InputSource />
            <button className="transparent block mx-a my-2">
              <img
                src={swapAni}
                alt="Swap Animation"
                className="w-7 h-7 filter-grey opacity-5 block"
              />
            </button>
            <InputDestination r={data.thorchainV2 || undefined} />
            <Quote />
          </div>
        </div>
      </div>
    </div>
  );
};
